/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { Currency } from '@app/settings/currencies/currency.model';
import { CurrenciesFormComponent } from '@app/settings/currencies/currencies-form/currencies-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class CurrenciesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open currency form
   * @param currency Dialog data
   */
  public open(currency: null | Currency = null): Promise<any> {
    const modal = this.modalService.open(CurrenciesFormComponent);
    modal.componentInstance.currency = currency;
    return modal.result;
  }
}
